// Encryption involves two layers. AES-GCM encryption with Symmetic secret key for encrypting the payload & RSA-OAEP with public-private key pairs (a.k.a Assymetric) for encrypting the symmetric key. RSA encryption has size constraints that prevents the use of RSA for a large payload encryption. Hence RSA will be used for encrypting only three items, 1) AES symmetric key, 2) AES iv, 3) one UUID
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var encryptionEnable = true;
function buf2hex(buffer) {
    // buffer is an ArrayBuffer
    return Array.prototype.map
        .call(new Uint8Array(buffer), function (x) { return ("00" + x.toString(16)).slice(-2); })
        .join("");
}
// from https://stackoverflow.com/a/11562550/9014097
function buf2Base64(buffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
}
export var hashingFeatures = function (val) { return __awaiter(void 0, void 0, void 0, function () {
    var inputBytes, hashBytes, hax;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                inputBytes = new TextEncoder().encode(val);
                return [4 /*yield*/, window.crypto.subtle.digest("SHA-256", inputBytes)];
            case 1:
                hashBytes = _a.sent();
                hax = JSON.stringify(buf2hex(hashBytes));
                return [2 /*return*/, hax];
        }
    });
}); };
// Convert  an ArrayBuffer into a string from https://developers.google.com/web/updates/2012/06/How-to-convert-ArrayBuffer-to-and-from-String
var ab2str = function (buf) {
    return String.fromCharCode.apply(null, new Uint8Array(buf));
};
// Convert a string into an ArrayBuffer from https://developers.google.com/web/updates/2012/06/How-to-convert-ArrayBuffer-to-and-from-String
var str2ab = function (str) {
    var buf = new ArrayBuffer(str.length);
    var bufView = new Uint8Array(buf);
    for (var i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
};
// Encode string into a form we can use for the encrypt operation.
var getMessageForEncryption = function (message) {
    var enc = new TextEncoder();
    return enc.encode(message);
};
// Convert base64 string into an Array buffer
var getArrayBuffer = function (message) {
    // base64 decode the string to get the binary data
    var binaryDerString = window === null || window === void 0 ? void 0 : window.atob(message);
    // convert from a binary string to an ArrayBuffer
    var genArrayBuffer = str2ab(binaryDerString);
    return genArrayBuffer;
};
// Generate RSA key pair
export var generateRsaKey = function () { return __awaiter(void 0, void 0, void 0, function () {
    var rsaAoepKeyPair;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, window.crypto.subtle.generateKey({
                    name: "RSA-OAEP",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([1, 0, 1]),
                    hash: "SHA-256",
                }, true, ["encrypt", "decrypt"])];
            case 1:
                rsaAoepKeyPair = _a.sent();
                return [2 /*return*/, rsaAoepKeyPair];
        }
    });
}); };
// Export the RSA public key for sharing.
export var exportRsaCryptoKey = function (publicKey) { return __awaiter(void 0, void 0, void 0, function () {
    var exported, exportedAsString, exportedAsBase64;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, window.crypto.subtle.exportKey("spki", publicKey)];
            case 1:
                exported = _a.sent();
                exportedAsString = ab2str(exported);
                exportedAsBase64 = window.btoa(exportedAsString);
                return [2 /*return*/, exportedAsBase64];
        }
    });
}); };
// Use base64 string to import RSA crypto Key Object
export var importRsaKey = function (publicKey) { return __awaiter(void 0, void 0, void 0, function () {
    var publicKeyArrBuffer, cryptoKeyObj;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                publicKeyArrBuffer = getArrayBuffer(publicKey);
                return [4 /*yield*/, window.crypto.subtle.importKey("spki", publicKeyArrBuffer, {
                        name: "RSA-OAEP",
                        hash: "SHA-256",
                    }, true, ["encrypt"])];
            case 1:
                cryptoKeyObj = _a.sent();
                return [2 /*return*/, cryptoKeyObj];
        }
    });
}); };
// Get the message, encoded it & encrypt using RSA-OAEP method
export var rsaEncryptMessage = function (publicKey, message) { return __awaiter(void 0, void 0, void 0, function () {
    var encoded, rsaCipheredtext, exportedAsString, exportedAsBase64;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encoded = getMessageForEncryption(message);
                return [4 /*yield*/, window.crypto.subtle.encrypt({
                        name: "RSA-OAEP",
                    }, publicKey, encoded)];
            case 1:
                rsaCipheredtext = _a.sent();
                exportedAsString = ab2str(rsaCipheredtext);
                exportedAsBase64 = window.btoa(exportedAsString);
                return [2 /*return*/, exportedAsBase64];
        }
    });
}); };
// Get the RSA-OAEP encrypted text, convert to array buffer & decrypt it
export var rsaDecryptMessage = function (privateKey, message) { return __awaiter(void 0, void 0, void 0, function () {
    var encryptedArrayBuffer, decrypted, dec, decryptedMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encryptedArrayBuffer = getArrayBuffer(message);
                return [4 /*yield*/, window.crypto.subtle.decrypt({
                        name: "RSA-OAEP",
                    }, privateKey, encryptedArrayBuffer)];
            case 1:
                decrypted = _a.sent();
                dec = new TextDecoder();
                decryptedMessage = dec.decode(decrypted);
                return [2 /*return*/, decryptedMessage];
        }
    });
}); };
// Generate AES-GCM secret key
export var generateAesKey = function () { return __awaiter(void 0, void 0, void 0, function () {
    var aesGcmSecretKey;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, window.crypto.subtle.generateKey({
                    name: "AES-GCM",
                    length: 256,
                }, true, ["encrypt", "decrypt"])];
            case 1:
                aesGcmSecretKey = _a.sent();
                return [2 /*return*/, aesGcmSecretKey];
        }
    });
}); };
// Export the AES-GCM secret key for sharing.
export var exportAesCryptoKey = function (key) { return __awaiter(void 0, void 0, void 0, function () {
    var exported, exportedKeyBuffer, exportedAsString, exportedAsBase64;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, window.crypto.subtle.exportKey("raw", key)];
            case 1:
                exported = _a.sent();
                exportedKeyBuffer = new Uint8Array(exported);
                exportedAsString = ab2str(exportedKeyBuffer);
                exportedAsBase64 = window.btoa(exportedAsString);
                return [2 /*return*/, exportedAsBase64];
        }
    });
}); };
// Use base64 string to import AES secret Key
export var importAesKey = function (key) { return __awaiter(void 0, void 0, void 0, function () {
    var rawKey, cryptoKeyObj;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rawKey = getArrayBuffer(key);
                return [4 /*yield*/, window.crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["encrypt", "decrypt"])];
            case 1:
                cryptoKeyObj = _a.sent();
                return [2 /*return*/, cryptoKeyObj];
        }
    });
}); };
// Get the message, encoded it & encrypt using AES-GCM method
export var aesEncryptMessage = function (key, message) { return __awaiter(void 0, void 0, void 0, function () {
    var encoded, iv, ivString, ivBase64, aesCipheredtext, exportedAsString, exportedAsBase64, aesEncryptObject;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encoded = getMessageForEncryption(message);
                iv = window.crypto.getRandomValues(new Uint8Array(12));
                ivString = ab2str(iv);
                ivBase64 = window.btoa(ivString);
                return [4 /*yield*/, window.crypto.subtle.encrypt({
                        name: "AES-GCM",
                        iv: iv,
                    }, key, encoded)];
            case 1:
                aesCipheredtext = _a.sent();
                exportedAsString = ab2str(aesCipheredtext);
                exportedAsBase64 = window.btoa(exportedAsString);
                aesEncryptObject = {
                    aesCipheredText: exportedAsBase64,
                    ivBase64: ivBase64,
                };
                return [2 /*return*/, aesEncryptObject];
        }
    });
}); };
// Get the AES-GCM encrypted text, convert to array buffer & decrypt it
export var aesDecryptMessage = function (key, ivBase64, message) { return __awaiter(void 0, void 0, void 0, function () {
    var encryptedArrayBuffer, iv, decrypted, dec, decryptedMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encryptedArrayBuffer = getArrayBuffer(message);
                iv = getArrayBuffer(ivBase64);
                return [4 /*yield*/, window.crypto.subtle.decrypt({
                        name: "AES-GCM",
                        iv: iv,
                    }, key, encryptedArrayBuffer)];
            case 1:
                decrypted = _a.sent();
                dec = new TextDecoder();
                decryptedMessage = dec.decode(decrypted);
                return [2 /*return*/, decryptedMessage];
        }
    });
}); };
var exportRsaPublicKey;
export var encryption = function (SPK, data) { return __awaiter(void 0, void 0, void 0, function () {
    var importedRsaCryptoKeyObj, aesGcmKey, exportAesSecretKey, _a, aesCipheredText, ivBase64, headerPayload, cipheredheaderPayload, rsaAoepKeyPair, header, reqObj;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                window.sessionStorage.setItem("serverPublicKey", SPK);
                return [4 /*yield*/, importRsaKey(SPK)];
            case 1:
                importedRsaCryptoKeyObj = _b.sent();
                return [4 /*yield*/, generateAesKey()];
            case 2:
                aesGcmKey = _b.sent();
                return [4 /*yield*/, exportAesCryptoKey(aesGcmKey)];
            case 3:
                exportAesSecretKey = _b.sent();
                return [4 /*yield*/, aesEncryptMessage(aesGcmKey, data)];
            case 4:
                _a = _b.sent(), aesCipheredText = _a.aesCipheredText, ivBase64 = _a.ivBase64;
                headerPayload = {
                    reqId: Date.now(),
                    clientSymmetric: exportAesSecretKey,
                    clientIv: ivBase64,
                };
                return [4 /*yield*/, rsaEncryptMessage(importedRsaCryptoKeyObj, JSON.stringify(headerPayload))];
            case 5:
                cipheredheaderPayload = _b.sent();
                return [4 /*yield*/, generateRsaKey()];
            case 6:
                rsaAoepKeyPair = _b.sent();
                return [4 /*yield*/, exportRsaCryptoKey(rsaAoepKeyPair.publicKey)];
            case 7:
                exportRsaPublicKey = _b.sent();
                window.sessionStorage.setItem("clientPublicKey", exportRsaPublicKey);
                header = {
                    SEPRK: cipheredheaderPayload,
                    CPK: exportRsaPublicKey,
                };
                reqObj = aesCipheredText;
                return [2 /*return*/, { header: header, reqObj: reqObj, rsaAoepKeyPair: rsaAoepKeyPair }];
        }
    });
}); };
export var decryption = function (CEPRK, response, rsaAoepKeyPair) { return __awaiter(void 0, void 0, void 0, function () {
    var rsaDecrytedText, rsaDecrytedobj, importedAesCryptoKeyObj, aesDecrytedText, decrytedText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, rsaDecryptMessage(rsaAoepKeyPair.privateKey, CEPRK)];
            case 1:
                rsaDecrytedText = _a.sent();
                rsaDecrytedobj = JSON.parse(rsaDecrytedText);
                return [4 /*yield*/, importAesKey(rsaDecrytedobj.symmetricSecret)];
            case 2:
                importedAesCryptoKeyObj = _a.sent();
                return [4 /*yield*/, aesDecryptMessage(importedAesCryptoKeyObj, rsaDecrytedobj.responseIV, response)];
            case 3:
                aesDecrytedText = _a.sent();
                decrytedText = JSON.parse(aesDecrytedText);
                return [2 /*return*/, decrytedText];
        }
    });
}); };
